import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionTracker } from '../components/collectes/CollectionTracker';
import { CollectionList } from '../components/collectes/CollectionList';
import { ReminderPreferences } from '../components/collectes/ReminderPreferences';
export function MesCollectes() {
  const [remindersOpen, setRemindersOpen] = useState(false);
  return <main className="bg-white" data-id="element-2086" data-mp="3q4gsulndao61">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2087" data-mp="3q5jjcsgs2olf">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2088" data-mp="3u492l1ohz0cz">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-blue" data-id="element-2089" data-mp="300w82vl4gwp">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2090" data-mp="7v7w0zlqh1gc" />
          <span aria-current="page" data-id="element-2091" data-mp="83ofg395nhnx">My Collections</span>
        </nav>

        <header className="mt-4" data-id="element-2092" data-mp="32qwhogbmjld">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2093" data-mp="31p9qmpy08nt">
            <Link to="/my-collections/calendar" className="group inline-flex items-center gap-2 rounded transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2094" data-mp="3v7cmpsxxonff">
              My Collections
              <ChevronRightIcon className="h-7 w-7 text-slate-400 transition-[transform,color] duration-150 ease-ville group-hover:translate-x-0.5 group-hover:text-ville-indigo lg:h-8 lg:w-8" aria-hidden="true" data-id="element-2095" data-mp="ms2f65b9yq09" />
              <span className="sr-only" data-id="element-2096" data-mp="d0euqod4y98a">See the full calendar</span>
            </Link>
          </h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-2097" data-mp="1ahdj1vnx90im">
            Check your next collections and get the details for your address in seconds.
          </p>
        </header>

        <div className="mt-8" data-id="element-2098" data-mp="1omnmtieufwfb">
          <AtnaAssistant data-id="element-2099" data-mp="1oogk473kh4an" />
        </div>

        <div className="mt-6" data-id="element-2100" data-mp="1tlgpsgwi8518">
          <AddressCard data-id="element-2101" data-mp="1tkp17q1br7kg" />
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[380px_minmax(0,1fr)] lg:gap-8" data-id="element-2102" data-mp="1ftshkopdm0pj">
          <CollectionTracker remindersOpen={remindersOpen} onToggleReminders={() => setRemindersOpen(current => !current)} data-id="element-2103" data-mp="1frzetkhvw0mt" />
          <div className="flex min-w-0 flex-col" data-id="element-2104" data-mp="15v355bg918go">
            <CollectionList data-id="element-2105" data-mp="15ubaq3ye1grz" />
            <AnimatePresence data-id="element-2106" data-mp="1aupkbqfn0ys4">
              {remindersOpen && <ReminderPreferences key="reminder-preferences" onClose={() => setRemindersOpen(false)} data-id="element-2107" data-mp="1avihq0spibxl" />}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </main>;
}